import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

const exportToExcel = async (tableData, fileName = "table-data.xlsx") => {
  // Create a new workbook and add a worksheet
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Sheet 1");

  // Add data to the worksheet
  tableData.forEach((row, rowIndex) => {
    const rowData = worksheet.addRow(row);

    // Apply styles
    rowData.eachCell((cell) => {
      // Add border to all cells
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };

      // Bold font for the header row
      if (rowIndex === 0) {
        cell.font = { bold: true };
        cell.alignment = { horizontal: "center" }; // Center align header
      }
    });
  });

  // Set column widths (optional)
  worksheet.columns = tableData[0].map(() => ({ width: 20 }));

  // Generate the Excel file
  const buffer = await workbook.xlsx.writeBuffer();

  // Save the file
  const blob = new Blob([buffer], { type: "application/octet-stream" });
  saveAs(blob, fileName);
};

export default exportToExcel;
